<script setup>
defineOptions({ name: 'DsField' });

defineProps({
  label: { type: String, default: null },
  required: { type: Boolean, default: false },
  hint: { type: String, default: null },
  error: { type: String, default: null },
  htmlFor: { type: String, default: null }
});
</script>

<template>
  <div class="ds-field">
    <label
      v-if="label"
      class="ds-field__label"
      :for="htmlFor"
    >
      {{ label }}<span
        v-if="required"
        class="ds-field__req"
        aria-hidden="true"
      >*</span>
    </label>
    <slot />
    <div
      v-if="error"
      class="ds-field__error"
    >
      {{ error }}
    </div>
    <div
      v-else-if="hint"
      class="ds-field__hint"
    >
      {{ hint }}
    </div>
  </div>
</template>
